import { useEffect } from 'react';

import type { UsePageTitleParams } from './usePageTitle.types';

export function usePageTitle({ mainTitle, suffix }: UsePageTitleParams) {
  useEffect(() => {
    document.title = suffix ? `${mainTitle} - ${suffix}` : `${mainTitle}`;
  }, [mainTitle, suffix]);
}
